import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

export function KnockoutTieGamesCount() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Партии при ничьей</FormLabel>
      <FormInput>
        <Controller
          name="knockOutSettings.tieSettings.additionalGamesCount"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input
              invisible
              type="number"
              rightLabel="на раунд"
              value={value.toString()}
              onChange={onChange}
              min="0"
              max="8"
              disabled={disabled}
            />
          )}
        />
        <Controller
          name="knockOutSettings.tieSettings.additionalGamesFinalCount"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input
              invisible
              type="number"
              rightLabel="на финал"
              value={value.toString()}
              onChange={onChange}
              min="0"
              max="8"
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
